import { render, staticRenderFns } from "./PFArrDeclarationSettings.vue?vue&type=template&id=3d117486"
import script from "./PFArrDeclarationSettings.vue?vue&type=script&lang=js"
export * from "./PFArrDeclarationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports